import React, { useEffect, useState, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { ConfigProvider, message } from 'antd';
// import CryptoJS from 'crypto-js';
import store from './redux/store';
import Admin from './routes/admin';
import Auth from './routes/auth';
import Logo from './static/img/Logo/LoadingLogo.png';
// import Loading from './static/img/Logo/splashScreen.mp4';
import { setEditCall } from './redux/CrmReduxCalls/EditNavCtrl';
// import { fetchApiData } from './redux/CrmReduxCalls/DealPipeline';
// import { fetchEmailData } from './redux/CrmReduxCalls/EmailConfigCheck';
// import { FetchAllAccount } from './Api/Services/AccountApiService'
// import { FetchAllDeal } from './Api/Services/DealApiService'
// import { getCasebuReportingUser, getFollowingCasebyUser } from './Api/Services/CaseApiServices'
// import { getCompanyCommunication } from './Api/Services/ProductConfigApiService';
import { setUserData, clearUserData, } from './redux/CrmReduxCalls/LocalDataReduxStore';
import ResetPassword from './routes/resetPassword';
// import LicenceUpdate from './container/dashboard/Pages/GrowSquare/LicenceUpdate';
import './static/css/style.css';
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute'
import 'antd/dist/antd.less';
import { FindLicenseManager } from './Api/Services/LicenceManagerApiService'

const { theme } = config;

function ProviderConfig() {
  const INACTIVITY_TIMEOUT = Number(process.env.REACT_APP_INACTIVITY_TIMEOUT)
  const inactivityTimer = useRef(null);
  const dispatch = useDispatch();
  const [isLoggedIn, setIsLogrdIn] = useState();
  const [accessToApp, setAccessToApp] = useState(false);
  const { rtl, topMenu, darkMode } = useSelector((state) => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });
  const [path, setPath] = useState(window.location.pathname);
  async function getDetails() {
    if (isLoggedIn !== undefined && isLoggedIn !== null) {
      const response = await FindLicenseManager()
      dispatch(setUserData({
        role: response.role,
        status: response.licenseManagerStatus,
        // permissions: response.data.data.permissionFor,
        profile: response,
      }));
      if (response.licenseManagerStatus) {
        setAccessToApp(true)
      }
      else {
        message.error("Your account is inactive, please contact your admin");
        setAccessToApp(false)
        window.localStorage.removeItem('cxs_expiration');
        window.localStorage.removeItem('cxs_lastActivityTime');
        dispatch(clearUserData());
      }
    }
    else {
      setAccessToApp(false)
    }
  }
  const fetchAll = async () => {
    await Promise.allSettled([
    ])
  };
  const SignOut = async () => {
    try {
      message.warning("Your session has expired due to inactivity. Please log in again to continue");
      setTimeout(() => {
        document.body.innerHTML = "";
        window.localStorage.removeItem('cxs_expiration');
        window.localStorage.removeItem('cxs_lastActivityTime');
        dispatch(clearUserData());
        window.location.replace("/");
      }, 1200);
    } catch (err) {
      message.error("Logout Failed");
    }
  };
  const resetInactivityTimer = () => {
    localStorage.setItem("cxs_lastActivityTime", Date.now().toString());
    if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
    inactivityTimer.current = setTimeout(() => {
      SignOut();
    }, INACTIVITY_TIMEOUT);
  };
  useEffect(() => {
    if (isLoggedIn) {
      getDetails();
      const activityEvents = [
        "mousemove",
        "mousedown",
        "keydown",
        "scroll",
        "touchstart",
        "click",
        "wheel"
      ];
      activityEvents.forEach((event) =>
        document.addEventListener(event, resetInactivityTimer, { passive: true })
      );
      resetInactivityTimer();
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          const last = parseInt(localStorage.getItem("cxs_lastActivityTime") || Date.now(), 10);
          if (Date.now() - last > INACTIVITY_TIMEOUT) {
            SignOut();
          } else {
            resetInactivityTimer();
          }
        }
      };
      window.addEventListener("focus", handleVisibilityChange);
      window.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        activityEvents.forEach((event) =>
          document.addEventListener(event, resetInactivityTimer, { passive: true })
        );
        window.removeEventListener("focus", handleVisibilityChange);
        window.removeEventListener("visibilitychange", handleVisibilityChange);
        if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
      };
    }
  }, [isLoggedIn]);
  useEffect(() => {
    if (isLoggedIn) {
      dispatch(setEditCall(false))
      fetchAll();
    }
  }, [dispatch, isLoggedIn]);
  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    const currentPath = window.location.pathname;
    const isResetPasswordRoute = currentPath.includes('/Home/reset-password');
    if (isResetPasswordRoute) {
      dispatch(clearUserData());
      setAccessToApp(true);
    } else {
      const urlToken = new URLSearchParams(window.location.search).get('token');
      if (urlToken) {
        const expirationDate = new Date().getTime();
        const expirationDays = expirationDate + (2 * 60 * 60 * 1000)
        localStorage.setItem("cxs_expiration", expirationDays);
        setIsLogrdIn(urlToken)
      } else {
        setIsLogrdIn(localStorage.getItem('cxs_expiration'))
      }
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [setPath,]);
  const isResetPassword = path === "/Home/reset-password";
  // const isLicenceUpdate = path === "/Home/licence-update";
  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <Router basename={process.env.PUBLIC_URL}>
          <Route path="/Home/reset-password" component={ResetPassword} />
          {/* <Route path="/Home/licence-update" component={LicenceUpdate} /> */}
          {/* {(!isResetPassword && !isLicenceUpdate) && ( */}
          {!isResetPassword && (
            <>{!accessToApp ? <Route path="/" component={Auth} /> : <ProtectedRoute path="/Home" component={Admin} />}
              {accessToApp && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && <Redirect to="/Home" />}</>
          )}
        </Router>
      </ThemeProvider>
    </ConfigProvider >
  );
}

function App() {
  const FontLink = () => (
    <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&display=swap');
    *{box-sizing:border-box;margin:0;padding:0;}
    body,html{font-family:'Noto Sans',sans-serif}
    button{font-family:'Noto Sans',sans-serif;}
    input,select,textarea{font-family:'Noto Sans',sans-serif;}
    @keyframes fadeSlideIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
    @keyframes shimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}
    .card-enter{animation:fadeSlideIn 0.22s ease both;}
    .row-hover:hover{background:#F5F6FF!important;transition:background 0.12s;}
    .btn-primary:hover{transform:translateY(-1px);box-shadow:0 4px 14px rgba(95,99,242,0.35);}
    .btn-primary:active{transform:translateY(0);}
    .btn-white:hover{background:#F5F6FF!important;color:#5A5F7D!important;
    // border-color:#5F63F2!important;
    }
    .btn-danger:hover{background:#E30D0F!important;}
    .btn-success:hover{background:#0CAB7C!important;}
    .tab-btn{position:relative;transition:color 0.15s;}
    .tab-btn::after{content:'';position:absolute;bottom:-1px;left:0;right:0;height:2px;border-radius:2px 2px 0 0;background:#5F63F2;transform:scaleX(0);transition:transform 0.2s ease;}
    .tab-btn.active::after{transform:scaleX(1);}
    .plan-card:hover{border-color:#5F63F2!important;box-shadow:0 4px 20px rgba(95,99,242,0.12)!important;}
    .plan-card{transition:border-color 0.15s,box-shadow 0.15s;}
    .seg-btn{transition:all 0.15s;}
    .seg-btn.active{background:#5F63F2!important;color:#fff!important;box-shadow:0 2px 8px rgba(95,99,242,0.3);}
    // input:focus,select:focus{outline:none;border-color:#5F63F2!important;box-shadow:0 0 0 3px rgba(95,99,242,0.1);}
    ::-webkit-scrollbar{width:6px;height:6px;}
    ::-webkit-scrollbar-track{background:#F0F2F8;}
    ::-webkit-scrollbar-thumb{background:#D0D3E8;border-radius:3px;}
    ::-webkit-scrollbar-thumb:hover{background:#9299B8;}
    .modal-overlay{animation:fadeSlideIn 0.18s ease both;}
    @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
  `}</style>
  );
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);
  const loadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f2f5',
  };
  return (
    <Provider store={store}>
      <FontLink />
      <div style={{ position: 'relative' }}>
        {loading && (
          <div style={loadingStyle}>
            <img src={Logo} alt="App Logo" style={{ width: '6%' }} />
          </div>
        )}
        <div style={{ display: loading ? 'none' : undefined }}>
          <ProviderConfig />
        </div>
      </div>
    </Provider>
  );
}

export default hot(App);